import { gql } from "@edreamsodigeo/frontend-api-client";

const TRIP_FRAGMENT = gql`
  fragment TripFragment on Trip {
    id
    bookingStatus
    bookingProductStatus
    buyer {
      name
      lastNames
      mail
    }
    prime
    primeMembershipContracted
    creationDate
    price {
      amount
      currency
    }
  }
`;

const USER_MEMBERSHIP_INFORMATION_FRAGMENT = gql`
  fragment UserMembershipInformation on UserMembership {
    isActive
  }
`;

export const GET_TRIP = gql`
  ${TRIP_FRAGMENT}
  ${USER_MEMBERSHIP_INFORMATION_FRAGMENT}
  query getTrip($token: String!) {
    getTrip: getTripByToken(token: $token) {
      trip {
        ...TripFragment
      }
      userMembership {
        ...UserMembershipInformation
      }
    }
  }
`;
